<template>
  {{ getGenderLabel(title) }}
</template>

<script setup lang="ts">
import { getGenderLabel } from '~/composables/userUtils';

defineProps({
  title: {
    type: String,
    required: true,
  },
});
</script>
